export const hideSAPApprovalView =
  (import.meta.env.VITE_HIDE_APPROVAL_SAP_VIEW && import.meta.env.VITE_HIDE_APPROVAL_SAP_VIEW === 'true') ||
  window.ENV.HIDE_APPROVAL_SAP_VIEW

export const hideStoreToSAPPage =
  (import.meta.env.VITE_HIDE_STORE_TO_SAP_PAGE && import.meta.env.VITE_HIDE_STORE_TO_SAP_PAGE === 'true') ||
  window.ENV.HIDE_STORE_TO_SAP_PAGE

export const someSAPViewIsInable = !hideSAPApprovalView || !hideStoreToSAPPage
